export default __webpack_public_path__ + "static/media/prize-5-bm.553b135f.webp";